import { FC, memo } from 'react'
import { Button } from '@chakra-ui/react'

import CostCenterCard from 'InstitutionalManagement/components/CostCenterCard'
import { CostCenter } from 'InstitutionalManagement/types'
import { useCustomFormViewer } from 'components/tools/CustomForm/components/Viewer/contexts/CustomFormViewerManager/Provider'
import { useCustomFormCostCenterSelectionDrawerManager } from '../../../../contexts/CustomFormCostCenterSelectionDrawerManager/Provider'

type Props = {
  costCenter: CostCenter
  onClose: () => void
}

const CustomFormCostCenterCardToSelect: FC<Props> = ({ costCenter, onClose }) => {
  const { questionKey, selectedCostCenter, setSelectedCostCenter, filter } =
    useCustomFormCostCenterSelectionDrawerManager()

  const { formMethods } = useCustomFormViewer()

  function selectCostCenter(selectedCostCenter: CostCenter) {
    formMethods?.setValue(questionKey, [selectedCostCenter.id, selectedCostCenter.slug, selectedCostCenter.name])
    setSelectedCostCenter(selectedCostCenter)
  }

  function removeCostCenter() {
    formMethods?.setValue(questionKey, undefined)
    setSelectedCostCenter({})
  }

  return (
    <CostCenterCard costCenter={costCenter} costCenterFilter={filter}>
      {selectedCostCenter?.id === costCenter.id ? (
        <Button width="100%" variant="outline" colorScheme="red" onClick={() => removeCostCenter()}>
          Remover
        </Button>
      ) : (
        <Button
          width="100%"
          variant="outline"
          onClick={() => {
            selectCostCenter(costCenter)
            onClose()
          }}
        >
          Selecionar
        </Button>
      )}
    </CostCenterCard>
  )
}

export default memo(CustomFormCostCenterCardToSelect)
